// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__rXazE","gfeWrapper":"CalendarEvent_gfeWrapper__3S-g7"};